import * as React from 'react';

function SvgParkingFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="#171717"
        d="M11.94 22.009H3.927c-1.338 0-1.959-.614-1.959-1.938V4.006c0-1.374.6-1.977 1.964-1.977h16.071c1.347 0 1.97.628 1.971 1.98v16.022c0 1.343-.633 1.976-1.974 1.976-2.69.003-5.374.002-8.06.002zM8.864 12c0 1.564-.004 3.126.002 4.69.001.455.314.82.69.832.415.014.723-.329.728-.825.005-.576.012-1.151-.004-1.725-.007-.274.09-.366.357-.352.368.018.738 0 1.106.005.828.01 1.635-.014 2.417-.378 1.5-.7 2.523-2.464 2.308-4.077-.241-1.804-1.546-3.233-3.243-3.52-1.157-.198-2.325-.058-3.487-.086-.641-.016-.874.233-.874.881-.002 1.518 0 3.036 0 4.555z"
      />
      <path
        fill="#fff"
        d="M8.864 12.001c0-1.52-.002-3.039 0-4.557.002-.648.233-.897.874-.881 1.163.028 2.33-.112 3.487.085 1.696.288 3.002 1.717 3.244 3.52.215 1.615-.81 3.378-2.309 4.078-.782.366-1.59.389-2.417.378-.368-.005-.738.013-1.105-.005-.269-.012-.365.078-.358.352.016.574.01 1.15.004 1.725-.004.494-.313.837-.729.825-.375-.012-.687-.377-.69-.832-.005-1.56-.001-3.124-.001-4.688zm1.422-1.455c0 .751.01 1.503-.006 2.255-.007.293.059.426.388.414.618-.025 1.239.002 1.857-.012 1.375-.032 2.545-1.243 2.536-2.613-.009-1.399-1.153-2.582-2.536-2.609-.619-.012-1.239.014-1.857-.01-.325-.013-.396.113-.39.41.018.72.008 1.443.008 2.165z"
      />
      <path
        fill="#171717"
        d="M10.286 10.546c0-.722.012-1.445-.006-2.167-.007-.295.064-.423.39-.41.618.025 1.238-.002 1.857.01 1.382.029 2.527 1.21 2.536 2.61.009 1.37-1.16 2.582-2.536 2.612-.619.014-1.24-.013-1.857.012-.33.013-.393-.12-.388-.414.014-.75.004-1.502.004-2.253z"
      />
    </svg>
  );
}

export default SvgParkingFilled;
